var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindsock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0667 4.1665L8.33334 3.60817L5.83334 3.39984V2.49984C5.83334 2.27882 5.74554 2.06686 5.58926 1.91058C5.43298 1.7543 5.22102 1.6665 5.00001 1.6665C4.77899 1.6665 4.56703 1.7543 4.41075 1.91058C4.25447 2.06686 4.16667 2.27882 4.16667 2.49984V17.4998C4.16667 17.7208 4.25447 17.9328 4.41075 18.0891C4.56703 18.2454 4.77899 18.3332 5.00001 18.3332C5.22102 18.3332 5.43298 18.2454 5.58926 18.0891C5.74554 17.9328 5.83334 17.7208 5.83334 17.4998V11.5998L8.33334 11.3915L15.0667 10.8332C15.2759 10.8164 15.4711 10.7212 15.6133 10.5667C15.7554 10.4122 15.834 10.2098 15.8333 9.99984V4.99984C15.834 4.7899 15.7554 4.58745 15.6133 4.43295C15.4711 4.27846 15.2759 4.1833 15.0667 4.1665ZM7.50001 9.7915L5.83334 9.92484V5.07484L7.50001 5.20817V9.7915ZM10.8333 9.50817L9.16667 9.64984V5.34984L10.8333 5.4915V9.50817ZM14.1667 9.23317L12.5 9.37484V5.62484L14.1667 5.7665V9.23317Z",
    fill: "#325CCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindsock);
export default __webpack_public_path__ + "static/media/windsock.f2f33c34.svg";
export { ForwardRef as ReactComponent };